import ArrowBackIosNewRoundedIcon from '@mui/icons-material/ArrowBackIosNewRounded';
import CloseIcon from '@mui/icons-material/Close';
import { Box, Divider, IconButton, Typography } from '@mui/material';
import * as styles from './styles';
import { ModalHeaderProps } from './types';

const ModalHeader: React.FC<ModalHeaderProps> = ({
  title,
  subtitle,
  visibleGoBack,
  disableGoBack = false,
  onClickClose,
  onClickBack
}) => (
  <>
    <Box sx={styles.container}>
      {visibleGoBack && (
        <IconButton
          disabled={disableGoBack}
          color="default"
          aria-label="Go back to previous step"
          onClick={() => onClickBack()}
        >
          <ArrowBackIosNewRoundedIcon />
        </IconButton>
      )}
      {!visibleGoBack && <div />}
      <Box sx={styles.titleContainer}>
        <Typography variant="h6" component="h2">
          {title}
        </Typography>
        {subtitle && (
          <Typography variant="caption" sx={{ color: '#fff8' }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      <IconButton color="default" aria-label="Close modal" component="span" onClick={() => onClickClose()}>
        <CloseIcon />
      </IconButton>
    </Box>
    <Divider sx={styles.divider} />
  </>
);

export default ModalHeader;
